"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Analytics", {
  enumerable: true,
  get: function get() {
    return _analytics.Analytics;
  }
});
Object.defineProperty(exports, "segmentApiKeys", {
  enumerable: true,
  get: function get() {
    return _analytics.segmentApiKeys;
  }
});
Object.defineProperty(exports, "AnalyticsOptions", {
  enumerable: true,
  get: function get() {
    return _analytics2.AnalyticsOptions;
  }
});
Object.defineProperty(exports, "AnalyticsProps", {
  enumerable: true,
  get: function get() {
    return _analytics2.AnalyticsProps;
  }
});
Object.defineProperty(exports, "Logger", {
  enumerable: true,
  get: function get() {
    return _Logger.Logger;
  }
});
Object.defineProperty(exports, "ReactLogger", {
  enumerable: true,
  get: function get() {
    return _reactLogger.ReactLogger;
  }
});
Object.defineProperty(exports, "xpsPerformance", {
  enumerable: true,
  get: function get() {
    return _performance.xpsPerformance;
  }
});

var _analytics = require("./analytics");

var _analytics2 = require("./types/analytics");

var _Logger = require("./Logger");

var _reactLogger = require("./reactLogger");

var _performance = require("./performance");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFDQTs7QUFDQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7QW5hbHl0aWNzLCBzZWdtZW50QXBpS2V5c30gZnJvbSAnLi9hbmFseXRpY3MnO1xuZXhwb3J0IHtBbmFseXRpY3NPcHRpb25zLCBBbmFseXRpY3NQcm9wc30gZnJvbSAnLi90eXBlcy9hbmFseXRpY3MnO1xuZXhwb3J0IHtMb2dnZXJ9IGZyb20gJy4vTG9nZ2VyJztcbmV4cG9ydCB7UmVhY3RMb2dnZXJ9IGZyb20gJy4vcmVhY3RMb2dnZXInO1xuZXhwb3J0IHt4cHNQZXJmb3JtYW5jZX0gZnJvbSAnLi9wZXJmb3JtYW5jZSc7XG4iXX0=